import React from 'react';

/**
 * FM Flexi Pro brand mark (SKG Apps master asset).
 * Both `full` and `icon` variants render the same square badge — the logo
 * already bakes the "FM FLEXI PRO" wordmark into the design, so we just
 * scale it up for hero slots and down for sidebar/favicon.
 * - size in px controls rendered height (width auto-scales 1:1 since square)
 */
export default function BrandLogo({ variant = 'icon', size = 40, className = '', alt = 'FM Flexi Pro' }) {
  const src = variant === 'full' ? '/fm-logo-full.png' : '/fm-logo-icon.png';
  return (
    <img
      src={src}
      alt={alt}
      data-testid={variant === 'full' ? 'brand-logo-full' : 'brand-logo-icon'}
      className={`block object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
